import { useCallback } from 'react';
import { useSignInFlow as useSharedSignInFlow } from 'shared/hooks/auth.hooks';
import { SIGN_IN_FLOW_ERROR_CODE } from 'shared/constants';
import { redirectToLoginWithSSO } from 'src/helpers/sso';
import { useOauthConfig } from './use-oauth-config.hook';

export function useSignInFlow() {
  const { getConfigByProvider, generateAuthenticationUrl } = useOauthConfig();

  const redirectToOauth = useCallback(
    ({ provider, loginHint }) => {
      const config = getConfigByProvider(provider);
      if (!config) {
        return { error: SIGN_IN_FLOW_ERROR_CODE.OAUTH_PROVIDER_NOT_CONFIGURED };
      }
      window.location.href = generateAuthenticationUrl({ ...config, loginHint });
    },
    [getConfigByProvider, generateAuthenticationUrl],
  );

  return useSharedSignInFlow({
    redirectToSSO: redirectToLoginWithSSO,
    redirectToOauth,
  });
}
